import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getExperienceId } from '../ExperiencesApp/ExperiencesApp'
import { GuidePageViewer } from '../GuidePage/GuidesList/GuidePageViewer'
import { experienceGuidePageActions, experienceGuidePageSelectors } from 'data/resources/experienceGuidePages'

export class _PrintGuide extends React.PureComponent {
  componentDidMount () {
    this.props.loadGuides()
  }

  componentDidUpdate (prevProps) {
    const { match: { params }, loadGuides } = this.props
    if (prevProps.match.params?.experienceId !== params.experienceId) {
      loadGuides()
    }
  }

  render () {
    const { topGuides, childrenForId, guides } = this.props

    return (
      <div>
        {guides.size > 0 && topGuides.valueSeq().map(guide => (
          guide.isHeader
            ? childrenForId(guide.id).valueSeq().map(({ id }) => {
              const guide = guides.get(id)
              const header = guides.get(guide.experienceGuidePageId)
              return <div key={guide.id} style={{ pageBreakAfter: 'always' }}>
                <h1>{(header ? `${header.title}: ` : '') + `${guide.title}`}</h1>
                <GuidePageViewer guide={guide} />
              </div>
            })
            : <div key={guide.id} style={{ pageBreakAfter: 'always' }}>
              <h1>{guide.title}</h1>
              <GuidePageViewer guide={guide} />
            </div>
        ))}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadGuides: () => dispatch(experienceGuidePageActions.list({ experienceId }))
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    guides: experienceGuidePageSelectors.byExperienceId(state, experienceId),
    topGuides: experienceGuidePageSelectors.topGuides(state, experienceId),
    childrenForId: guideId => experienceGuidePageSelectors.childrenForId(state, guideId)
  }
}

export const PrintGuide = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(_PrintGuide))
